import { useQuery } from "@tanstack/react-query";
import { UserManagementService } from "@/services/user/userManagementService";
import { useAuth } from "@/hooks/useAuth";
import { UserType } from "@/types/user";

/** Current admin's permission flags (shares the `currentAdminProfile` query cache). */
export function useCurrentAdminPermissions() {
  const { user } = useAuth();
  const isAdmin = user?.type === UserType.Admin;
  const { data: adminProfile, isLoading } = useQuery({
    queryKey: ["currentAdminProfile"],
    queryFn: () => UserManagementService.getCurrentAdminProfile(),
    staleTime: 5 * 60 * 1000,
    enabled: isAdmin,
  });
  const permissions = adminProfile?.permissions;
  return {
    isLoading,
    permissions,
    canViewBidsOverview: permissions?.viewBidsOverview === true,
    canViewDashboardOverview: permissions?.viewDashboardOverview === true,
    canManageSettings: permissions?.manageSettings === true,
    canManageSupport: permissions?.manageSupport === true,
    canManageVehicles: permissions?.manageVehicles === true,
    canManageAdminPermissions: permissions?.manageAdminPermissions === true,
    // Drill-in is part of "Hantera annonser"; keep legacy flag for older grants.
    canViewLeadboxListings:
      permissions?.viewBidsOverview === true ||
      permissions?.viewLeadboxListings === true,
  };
}
